import { Injectable } from '@angular/core';

import { getCurrentUserEndpoint, loginEndpoint, logoutEndpoint } from 'client/sdk.gen';
import type { GetCurrentUserResponse } from 'client/types.gen';

import type { PtSignInCredentials } from './auth.types';

/**
 * Thin SDK adapter for authentication endpoints.
 *
 * Keeps auth transport details centralized in the template layer.
 */
@Injectable({ providedIn: 'root' })
export class PtAuthApiService {
  /** Sends user credentials to create a backend session cookie. */
  async signIn(credentials: PtSignInCredentials): Promise<void> {
    await loginEndpoint({ body: credentials, throwOnError: true });
  }

  /** Invalidates the current backend session cookie. */
  async signOut(): Promise<void> {
    await logoutEndpoint({ throwOnError: true });
  }

  /** Fetches the currently authenticated user profile. */
  async getCurrentUser(): Promise<GetCurrentUserResponse> {
    const { data } = await getCurrentUserEndpoint({ throwOnError: true });
    return data;
  }
}
